import { SMLRouteNames } from '../../../../../routing/sml/SMLRoutes';

/** The sections of the song page, in the order of the page (owner decision 2026-10-06: one long page). */
export const SONG_PAGE_SECTIONS = ['details', 'files', 'lyrics', 'release'] as const;

export type SongPageSection = (typeof SONG_PAGE_SECTIONS)[number];

/** The two views of the Lyrics section (design song-page d1, d2). */
export type SongLyricsView = 'times' | 'text';

/** `?tab=` of a link: a section name, else undefined (the page opens at its top). */
export function parseSongPageSection(value: string | null | undefined): SongPageSection | undefined {
  return SONG_PAGE_SECTIONS.find((section) => section === value);
}

/** The element id of a section. A `?tab=` link scrolls to it. */
export function songPageSectionId(section: SongPageSection): string {
  return `song-page-${section}`;
}

interface CatalogSongPathOptions {
  /** The section to scroll to (`?tab=`). The design used tabs; the value names a section now. */
  section?: SongPageSection;
  /** The artist of the row. The web switcher reads it (`resolveActiveAccountId.ts`). */
  accountId?: number | null;
  /** `text` opens the Text view of the Lyrics section. */
  view?: SongLyricsView;
}

/**
 * The path of the song page of one catalog row (design song-page a0):
 * `/catalog/song/<uuid>[?tab=<section>][&accountId=<id>][&view=text]`. The router adds `/app`.
 */
export function catalogSongPath(catalogItemUuid: string, options: CatalogSongPathOptions = {}): string {
  const query = new URLSearchParams();
  if (options.section !== undefined) {
    query.set('tab', options.section);
  }
  if (options.accountId !== undefined && options.accountId !== null) {
    query.set('accountId', String(options.accountId));
  }
  if (options.view === 'text') {
    query.set('view', 'text');
  }
  const search = query.toString();
  return `/${SMLRouteNames.catalog}/song/${encodeURIComponent(catalogItemUuid)}${search === '' ? '' : `?${search}`}`;
}
